import { useCallback } from "react"
import sanityClient from "@sanity/client"

import { useConfigContext } from "@providers/config"
// import { useCustomerContext } from "@providers/customer"
// import { useCore } from "@hooks/useCore"
// import { useRoutes, RouteOptions } from "@hooks/useRoutes"
// import { Link } from "@components/Link"

// import type { ProductProps } from "@root/types/global"

export const useSanity = () => {
  const {
    store: { sanityDataset, sanityProjectId, sanityApiVersion, sanityToken },
  } = useConfigContext()

  const client = sanityClient({
    dataset: sanityDataset,
    projectId: sanityProjectId,
    apiVersion: sanityApiVersion,
    token: sanityToken,
    useCdn: true,
  })

  const sanityFetch = useCallback(async (query: string, variables?: any) => await client.fetch(query, variables), [client])

  return { sanityFetch }
}

// export const useSanityArticles = ({ id }: useSanityArticleProps) => {
//   const [allArticles, setAllArticles] = useState([])
//   const [fetched, setFetched] = useState(false)
//   const [loading, setLoading] = useState(false)

//   const {
//     services: { sanity },
//   } = useConfigContext()
//   const sanityClient = createClient(sanity)
//   const fetchData = useCallback(async () => {
//     setLoading(true)

//     const sanityQuery = groq`*[ _type == 'article' && !(_id in path("drafts.**")) && _id != '${id}' && defined(attributes.publishedAt)] | order(attributes.publishedAt desc)[0...9]{
//         ...,
//         attributes { ..., author->, category-> },
//         image { ..., asset-> },
//         previewImage { ..., asset-> }
//       }`

//     try {
//       const data = await sanityClient.fetch(sanityQuery)
//       setAllArticles(data)
//       setFetched(true)
//     } catch (error) {
//       console.error(error)
//     }
//     setLoading(false)
//   }, [setLoading, id, sanityClient])

//   useEffect(() => {
//     if (!fetched) {
//       fetchData()
//     }
//   }, [fetched, fetchData])

//   return { allArticles, loading }
// }
